module.exports = __webpack_public_path__ + "441c7edbacea0f73a03db5ce0ad432e8.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/IniMusik_logo_kurz_color.png
// module id = 963
// module chunks = 0